<template>
  <ul :class="['language', { dark: isDark }]">
    <li>
      <font-awesome-icon :icon="['far', 'language']" size="lg" />
    </li>
    <li>
      <button @click="handleLocale('en-MY')">English.</button>
    </li>
    <li>
      <button @click="handleLocale('ms-MY')">Bahasa.</button>
    </li>
    <li>
      <button @click="handleLocale('zh-MY')">简体中文.</button>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.language {
  align-items: center;
  color: #222;
  display: flex;
  font-weight: 700;
  position: fixed;
  right: 1rem;
  top: 50%;
  transform-origin: right top;
  transform: rotate(-90deg) translate(50%, -100%);
  z-index: 10;

  &.dark {
    color: #fff;
  }

  li {
    &:first-child,
    &:not(:last-child) {
      &::after {
        content: '/';
        display: inline-block;
        margin-right: 0.5rem;
        padding-left: 0.5rem;
      }
    }

    &:first-child {
      &::after {
        content: '-';
      }
    }
  }

  @media (max-width: 767.98px) {
    display: none;
  }
}
</style>

<script>
export default {
  data() {
    return {
      isDark: true
    };
  },

  methods: {
    handleScroll: _.debounce(function () {
      var boundaryCache = 0,
        currentPosition = window.scrollY + window.innerHeight / 2;

      this.isDark = Array.from(document.querySelectorAll('section'))
        .filter((section) => currentPosition >= boundaryCache && currentPosition < (boundaryCache = section.getBoundingClientRect().bottom + window.scrollY))[0]
        .classList.contains('dark');
    }, 50),

    handleLocale(locale) {
      this.$i18n.global.locale.value = locale;
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted() {
    this.handleScroll();
  }
};
</script>
